import * as firebase from 'firebase';
const config = {
  apiKey: "AIzaSyDndtQw3VDDJri99MHuoTCrAQDSdN5vp6s",
  authDomain: "tictactoe-jolt.firebaseapp.com",
  databaseURL: "https://tictactoe-jolt.firebaseio.com",
  projectId: "tictactoe-jolt",
  storageBucket: "tictactoe-jolt.appspot.com",
  messagingSenderId: "1009894680943",
  appId: "1:1009894680943:web:98ff2a7cfaefbdbbfa609a",
  measurementId: "G-RS19VYQEW2"
};
firebase.initializeApp(config);

export default firebase;
